"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/cs");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  announcements_a4b8ed4a: {
    message: "Ozn\xE1men\xED"
  },
  assignments_1e02582c: {
    message: "\xDAkoly"
  },
  discussions_a5f96392: {
    message: "Diskuze"
  },
  files_c300e900: {
    message: "Soubory"
  },
  grades_a61eba0a: {
    message: "Prosp\u011Bch"
  },
  loading_25990131: {
    message: "Nahr\xE1v\xE1m..."
  },
  modules_c4325335: {
    message: "Moduly"
  },
  pages_e5414c2c: {
    message: "Str\xE1nky"
  },
  people_b4ebb13c: {
    message: "Lid\xE9"
  },
  quizzes_7e598f57: {
    message: "Kv\xEDzy"
  },
  upload_8b403d05: {
    message: "Nahr\xE1t"
  }
};

_formatMessage.default.addLocale({
  cs: locale
});